import { Plugin } from 'pleditor';
// ---- Private
const REVIEW_REDLINE_HIGHLIGHT_NAME = 'review-redline-highlight';
const REVIEW_REDLINE_HIGHLIGHT_CLASS = 'review-redline-highlight';
const singleton = {
    plugin: null,
    init: (plugin) => {
        singleton.plugin = plugin;
    },
    destroy: () => {
        singleton.plugin = null;
    },
};
// -- Helpers
const getChild = (el, path) => path.length === 0 || el === undefined || el === null
    ? el
    : getChild(el.getChild(path[0]), path.slice(1));
// ---- Public
export const withReviewPlugin = (fn) => {
    if (singleton.plugin) {
        return fn(singleton.plugin);
    }
    return null;
};
export const redline = (path, fromOffset, toOffset) => withReviewPlugin(p => {
    const name = `${REVIEW_REDLINE_HIGHLIGHT_NAME}-${Math.round(Math.random() * 100000)}`;
    p.editor.conversion.for('downcast').markerToHighlight({
        model: name,
        view: () => ({ classes: REVIEW_REDLINE_HIGHLIGHT_CLASS }),
        converterPriority: 'high',
    });
    p.editor.editing.view.change(viewWriter => {
        const node = getChild(p.editor.editing.view.document.getRoot(), path);
        console.log(node);
        if (!node)
            return;
        const viewRange = viewWriter.createRange(viewWriter.createPositionAt(node, fromOffset), viewWriter.createPositionAt(node, toOffset));
        const modelRange = p.editor.editing.mapper.toModelRange(viewRange);
        p.editor.model.change(modelWriter => {
            const marker = modelWriter.addMarker(name, {
                range: modelRange,
                usingOperation: false,
                affectsData: false,
            });
            console.log(marker);
        });
    });
});
export class ReviewPlugin extends Plugin {
    constructor() {
        super(...arguments);
        this.init = () => {
            // TODO: No need for a singleton pattern because all ckeditor plugins only have one instance. see https://github.com/pocketsolutions/app/pull/4068#discussion_r1530606055
            singleton.init(this);
        };
    }
    static get pluginName() {
        return 'Review';
    }
    destroy() {
        singleton.destroy();
        this.stopListening();
    }
}
